import { gql } from '@apollo/client';

export const fetchEmailsForEntitlementPage = gql`
  query fetchEmailsForEntitlementPage($id: String, $searchOptions: ConnectionSearchOptions) {
    entitlementDetails(id: $id) {
      id
      emails(searchOptions: $searchOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            subject
            size
            id
            html
            text
            date
            to {
              address
            }
            from {
              address
            }
          }
        }
      }
    }
  }
`;
